import { createTheme } from '@mui/material';

export const primaryTheme = createTheme({
  typography: {
    fontFamily: ['Open Sans'].join(''),
    button: {
      fontSize: '15px',
      fontWeight: 700,
      textTransform: 'none',
    },
  },
  palette: {
    primary: {
      main: '#006FF5',
    },
    action: {
      disabledBackground: 'rgba(0, 111, 245, 0.25)',
      disabled: 'white',
    },
  },
});
